import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import ActionCardsSlides from '../../components/action-cards-slides/ActionCardsSlides';
import PortfolioValueContainer from '../../components/user-portfolio-container/PortfolioValueContainer';
import './Home.css';

const Home: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Home</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Home</IonTitle>
          </IonToolbar>
        </IonHeader>
        <PortfolioValueContainer />
        <ActionCardsSlides />
      </IonContent>
    </IonPage>
  );
};

export default Home;
